// extracted by mini-css-extract-plugin
var _1 = "TopicBreadcrumbs-module__animateUploadProgressBarWidth--U_iy1";
var _2 = "TopicBreadcrumbs-module__animatedBackground--mVu0V";
var _3 = "TopicBreadcrumbs-module__container--TbfFU";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container" }
